import { CoreActivateGameView } from '../../../../core/views';

import './index.styl';
import template from './index.jst';
import Radio from "backbone.radio";
const channel = Radio.channel('coach');

class ActivateGameView extends CoreActivateGameView {
	get template() {
		return template;
	}

	getCustomUIElements() {
		return {
			fantasy_sponsor  : '.js-fantasy-sponsor',
		};
	}

	getCustomDefaultValues() {
		return {
			game_title : 'Fantasy',
			fantasy_sponsor: 0,
		};
	}

	getCustomFormValues() {
		return {
			fantasy_sponsor: this.getUI( 'fantasy_sponsor' ).filter( ':checked' ).val() ? 1 : 0,
		};
	}

	getCustomActivateRequestBody() {
		return {
			fantasy_sponsor: this.model.get('fantasy_sponsor'),
		};
	}

	completionRedirect() {
		// redirectTo('fantasy-coach');
		channel.trigger('show:popup');
		this.close();
	}
}

export default ActivateGameView;